//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: true
    },
    checked: {
      type: [Boolean, String],
      default: false
    }
    // selected: {
    //   type: Boolean,
    //   required: true
    // },
    // change: {
    //   type: Function,
    //   required: true
    // }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        input: (event) => {
          this.$emit('input', event.target.checked)
        }
      }
    }
  }
}
